/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Directive, Input, HostListener } from '@angular/core';

@Directive({
  selector: '[href]',
  standalone: false,
})
export class PreventHrefNavDirective {
  @Input() href: string;

  @HostListener('click', ['$event'])
  noop(event: MouseEvent) {
    if (this.href.length === 0 || this.href === '#') {
      event.preventDefault();
    }
  }
}
